const getTravelDates = () => {
  let currentDate = new Date();
  const travelDates = [];

  for (let i = 0; i < 9; i++) {
    let month = currentDate.toLocaleString('en-us', { month: 'short' }),
      year = currentDate.getFullYear().toString().substr(-2);

    if (currentDate.getMonth() === 11) {
      currentDate = new Date(currentDate.getFullYear() + 1, 0, 1);
    } else {
      currentDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1);
    }
    travelDates.push(month + " '" + year);
  }
  return travelDates;
};

export default getTravelDates;
